import { GameManager } from '../../managers/GameManager';
import { ScaleManager } from '../../managers/ScaleManager';
import { Button } from '../../ui/Button';
import { SceneManager } from '../../managers/SceneManager';
import { Scene } from '../../tools/Scene';
import { PauseScene } from './PauseScene';
import { HTPScene } from './HTPScene';
import { QuitScene } from './QuitScene';
import { LocalizationManager } from '../../managers/LocalizationManager';
import { GameType } from '../../models/CBNGameModel';
import { TitleScene } from './TitleScene';
import { HTPContainerScene } from './HTPContainerScene';
import { PreloaderUIScene } from './PreloaderUIScene';
import { IsLetter } from '../../tools/utils/string/IsLetter';
import { Fold } from '../../tools/utils/string/Fold';
import { EagleEyeExamGameSceneModel } from '../../viewModels/EagleEyeExamGameSceneModel';

export class EagleEyeExamGameScene extends Scene{

    //Scene's ViewModel
    viewModel:EagleEyeExamGameSceneModel;

    //Scene Components
    bg: Phaser.GameObjects.Image|null = null;

    //Quiz Components
    scoreContainer: Phaser.GameObjects.Sprite|null = null;
    scoreLabel: Phaser.GameObjects.Text|null = null;
    score: Phaser.GameObjects.Text|null = null;
    containerWhiteFx: Phaser.GameObjects.Sprite|null = null;
    scoreFxBar: Phaser.GameObjects.Sprite|null = null;
    scoreFxStar: Phaser.GameObjects.Sprite|null = null;
    roundContainer: Phaser.GameObjects.Sprite|null = null;
    roundLabel: Phaser.GameObjects.Text|null = null;
    round: Phaser.GameObjects.Text|null = null;
    lifeContainer: Phaser.GameObjects.Sprite|null = null;
    lifeLabel: Phaser.GameObjects.Text|null = null;
    lifeGroup:Phaser.GameObjects.Sprite[]|null = [];
    timerContainer: Phaser.GameObjects.Sprite|null = null;
    timerLabel2: Phaser.GameObjects.Text|null = null;
    timerCounter: Phaser.GameObjects.Text|null = null;
    pauseButton: Button|null = null;
    timerProgressBarBg:Phaser.GameObjects.Sprite|null = null;
    timerProgressBar: Phaser.GameObjects.Graphics|null = null;
    progressBarPosition:Phaser.Math.Vector2|null = null;
    progressBarWidth:number|null = null;
    progressBarHeight:number|null = null;
    progressBarValue:number = 0;
    progressBarColor:number = 0x000000;
    timerLabel:Phaser.GameObjects.Text|null = null;

    nextQuestionButton: Button|null = null;
    nextQuestionButtonPosition:Phaser.Math.Vector2|null = null;

    firstImageContainerSprite:Phaser.GameObjects.Sprite|null = null;
    firstImageSprite:Phaser.GameObjects.Sprite|null = null;
    secondImageContainerSprite:Phaser.GameObjects.Sprite|null = null;
    secondImageSprite:Phaser.GameObjects.Sprite|null = null;
    imageContainerTexture:string = '';

    firstZone:Phaser.GameObjects.Zone|null = null;
    secondZone:Phaser.GameObjects.Zone|null = null;
    graphics:Phaser.GameObjects.Graphics|null = null;

    //View States
    timerActive:boolean = false;
    nextQuestionButtonActive:boolean = false;

    //Additive Scenes
    preloaderUIScene:PreloaderUIScene|null = null;
    pauseScene: PauseScene;
    htpScene: HTPContainerScene;

    constructor(sceneConfig,viewModel:EagleEyeExamGameSceneModel){
        super(sceneConfig);
        this.viewModel = viewModel;
        this.gameManager = <GameManager>GameManager.instance;
        this.htpScene = new HTPContainerScene({key:'HTPContainerScene'+Math.random()},5);
        this.pauseScene = new PauseScene({key:'PauseScene'+Math.random()},5);
    }

    preload(){
        this.preloaderUIScene = new PreloaderUIScene(this);
        //Load Question Images from url
        for (let index = 0; index < this.viewModel.getFirstImageSources().length; index++) {
            const element = this.viewModel.getFirstImageSources()[index];
            //console.log('loading'+element);
            this.load.image('firstImage'+index,element);
        }
        //Load Answer Images from url
        for (let index = 0; index < this.viewModel.getSecondImageSources().length; index++) {
            const element = this.viewModel.getSecondImageSources()[index];
            this.load.image('secondImage'+index, element);
        }
    }

    prescaleCreate(){

        if(this.preloaderUIScene){
            this.preloaderUIScene.group.destroy(true);
        }

        //Add Additive Scenes and their event bindings
        this.scene.add('PauseScene',this.pauseScene,true);
        this.pauseScene.emitter.on('unpause',this.onUnpauseScene,this);
        this.pauseScene.emitter.on('quitquiz',this.onEndQuiz,this);
        window.addEventListener("blur", this.onPauseScene.bind(this),false);
        window.addEventListener("pagehide", this.onPauseScene.bind(this),false);
        window.addEventListener("webkitvisibilitychange", this.checkIfInterrupt.bind(this),false);
        window.addEventListener("visibilitychange", this.checkIfInterrupt.bind(this),false);

        //Put Additive scenes that are visible at start after this
        this.scene.bringToTop(undefined!);

        console.log("will display htp: ", this.gameManager.cbnGameConfig!.willDisplayHTP )
        if(this.gameManager.cbnGameConfig!.willDisplayHTP){
            this.scene.add('HTPContainerScene',this.htpScene,true);
            this.htpScene.emitter.on('close',this.closeHTP,this);
        }
        
        //Add Scene event bindings

        //Add viewModel event bindings
        this.viewModel.emitter.on('OnTimerEnd',this.onTimerEnd,this);
        this.viewModel.emitter.on('OnAttemptAnswer',this.showAttemptResults,this);
        this.viewModel.emitter.on('OnGiveAnswer',this.showQuestionResults,this);
        this.viewModel.emitter.on('OnQuizEnd',this.onEndQuiz,this);
        this.viewModel.emitter.on('OnTimerChanged',this.updateQuizTimer,this);

        //Holder variables
        let position;
        let labelSprite;
        let label;
        let button:Button;
        let image;
        let sprite:Phaser.GameObjects.Sprite;
        let text;
        let style;
        let zone:Phaser.GameObjects.Zone;
        let group:Phaser.GameObjects.Group;
        let graphics:Phaser.GameObjects.Graphics;

        let valueStyle = { fontFamily: 'Proximanova Regular', fontSize: 26, color: '#FFFFFF', align: 'center'};

        //Add Background
        position = this.scaleManager.getRelativePosition(.5,.5);
        this.bg = this.add.image(position.x,position.y,'lan_gen_bg');
        // this.bg.visible = false;

        //Add Score
        position = this.scaleManager.getRelativePosition(0.1,0.05);
        labelSprite = this.add.sprite(position.x,position.y,'gfx_container');
        this.scoreContainer = labelSprite;
        label = this.add.text(position.x-100,position.y,LocalizationManager.getText('SCORE'),LocalizationManager.getStyle('SCORE'));
        label.setOrigin(.5,.5);
        this.scoreLabel = label;
        this.score = this.add.text(position.x+50,position.y,this.viewModel.getCurrentScore().toString(),valueStyle);
        this.score.setOrigin(0,.5);

        

        if(this.gameManager.cbnGameConfig!.gameType == GameType.full){
            //Add Round
            position = this.scaleManager.getRelativePosition(0.3,0.05);
            labelSprite = this.add.sprite(position.x,position.y,'gfx_container');
            this.roundContainer = labelSprite;
            label = this.add.text(position.x-100,position.y,LocalizationManager.getText('ROUND'),LocalizationManager.getStyle('ROUND'));
            label.setOrigin(.5,.5);
            this.roundLabel = label;
            this.round = this.add.text(position.x+50,position.y,this.viewModel.getCurrentRoundNumber().toString(),valueStyle);
            this.round.setOrigin(0,.5);

            //Add Lives
            position = this.scaleManager.getRelativePosition(0.5,0.05);
            labelSprite = this.add.sprite(position.x,position.y,'gfx_container');
            this.lifeContainer = labelSprite;
            label = this.add.text(position.x-100,position.y,LocalizationManager.getText('LIVES'),LocalizationManager.getStyle('LIVES'));
            label.setOrigin(.5,.5);
            this.lifeLabel = label;
            for (let index = 0; index < this.viewModel.getMaxLife(); index++) {
                let life;
                life = this.add.sprite(position.x + 7.5 + index * 60 ,position.y,'gfx_life_on');
                this.lifeGroup!.push(life);
            }

            var minutes = Math.floor(Math.round(this.viewModel!.getGameTimeRemaining()) / 60);
            var seconds = Math.round(this.viewModel!.getGameTimeRemaining()) - minutes * 60;
            var timeLeft;
            if(seconds.toString().length == 1)
            {
                timeLeft = minutes + ":0" + seconds;
            }
            else timeLeft = minutes + ":" + seconds;
                

            //Add Timer
            position = this.scaleManager.getRelativePosition(0.7,0.05);
            labelSprite = this.add.sprite(position.x,position.y,'gfx_container');
            this.timerContainer = labelSprite;
            label = this.add.text(position.x-55,position.y,LocalizationManager.getText('TIME'),LocalizationManager.getStyle('TIME'));
            label.setOrigin(.5,.5);
            this.timerLabel2 = label;
            this.timerCounter = this.add.text(position.x+10,position.y,timeLeft,valueStyle);
            this.timerCounter.setOrigin(0,.5);

            //set lives and timer to invisible if it's practice mode
            if(this.viewModel.getIsPractice()){
                this.lifeContainer!.visible = false;
                this.lifeLabel!.visible = false;
                for(let i = 0; i < this.lifeGroup!.length ; i++)
                {
                    this.lifeGroup![i].visible = false;
                }

                this.timerContainer!.visible = false;
                this.timerCounter!.visible = false;
                this.timerLabel2!.visible = false;
            }
        }
        else
        {
            this.lifeGroup = null;
        }


        //Add Images
        position = this.scaleManager.getRelativePosition(0.25,0.5);
        sprite = this.add.sprite(position.x,position.y,'lan_image_holder');
        this.firstImageContainerSprite = sprite;
        sprite = this.add.sprite(position.x,position.y,'firstImage'+(this.viewModel.getCurrentRoundNumber()-1));
        this.firstImageSprite = sprite;

        zone = this.add.zone(position.x-(sprite.width/2),position.y-(sprite.height/2),sprite.width,sprite.height);
        zone.setName('firstZone');
        zone.setInteractive();
        zone.on('pointerdown',this.onZoneDown,this);
        this.firstZone = zone;
        
        position = this.scaleManager.getRelativePosition(0.75,0.5);
        sprite = this.add.sprite(position.x,position.y,'lan_image_holder');
        this.secondImageContainerSprite = sprite;
        sprite = this.add.sprite(position.x,position.y,'secondImage'+(this.viewModel.getCurrentRoundNumber()-1));
        this.secondImageSprite = sprite;

        zone = this.add.zone(position.x-(sprite.width/2),position.y-(sprite.height/2),sprite.width,sprite.height);
        zone.setName('secondZone');
        zone.setInteractive();
        zone.on('pointerdown',this.onZoneDown,this);
        this.secondZone = zone;
        
        graphics = this.add.graphics({});
        graphics.lineStyle(5,0xea3142,1);
        this.graphics = graphics;

        //Add Timer
        if(this.viewModel.getIsPractice()==false){
            position = this.scaleManager.getRelativePosition(0.5,0.25);    
            this.timerProgressBarBg = this.add.sprite(position.x,position.y,'lan_timer_ctn');
            graphics = this.add.graphics({});
            this.timerProgressBar = graphics;
            graphics.clear();
            graphics.fillStyle(0x1999f1, 1);
            this.progressBarColor = 0x1999f1;
            graphics.fillRect(position.x-900, position.y-20, 1800 * this.viewModel.getTimerProgress(), 40);
            this.progressBarPosition = new Phaser.Math.Vector2(position.x-900, position.y-20);
            this.progressBarWidth = 1800;
            this.progressBarHeight = 40;
            label = this.add.text(position.x,position.y,LocalizationManager.getText('TIME'),LocalizationManager.getStyle('TIME'));
            label.setOrigin(.5,.5);
            this.timerLabel = label;
        }

        //Add Next Question Button
        position = this.scaleManager.getRelativePosition(0.5,1);
        button = new Button(this,'next_question_button',position.x,position.y-80);
        button.emitter.on('buttonup',this.showNextQuestion,this);
        button.buttonPressedSprite = 'next_question_button_pressed';
        button.text.setText(LocalizationManager.getText('NEXT'));
        button.text.setStyle(LocalizationManager.getStyle('NEXT'));
        this.nextQuestionButton = button;
        Phaser.Actions.SetVisible(this.nextQuestionButton!.group.getChildren(),false);
        this.input.disable(this.nextQuestionButton!.sprite);

        //Add Pause Button
        position = this.scaleManager.getRelativePosition(1,0.05);
        button = new Button(this,'pause_button',position.x-70,position.y,{});
        button.buttonHighlightSprite = 'pause_button';
        button.buttonPressedSprite = 'pause_button_pressed';
        //button.sprite.setOrigin(1,0);
        this.pauseButton = button;
        button.emitter.on('buttonup',this.onPauseScene,this);
        
        //FX
        sprite =  this.add.sprite(position.x,position.y,'gfx_container_white');
        sprite.setAlpha(0);
        this.containerWhiteFx = sprite;

        sprite =  this.add.sprite(position.x,position.y,'gfx_flare_long');
        sprite.setAlpha(0);
        this.scoreFxBar = sprite;
        
        sprite = this.add.sprite(position.x,position.y,'gfx_flare_star');
        sprite.setAlpha(0);
        this.scoreFxStar = sprite;
        
        //Initializations
        this.updateQuizView();
        this.timerActive = false;
        this.scene.pause(undefined!);

        if(this.gameManager.cbnGameConfig!.willDisplayHTP){
            this.htpScene.startOpen();
            this.gameManager.cbnGameConfig!.willDisplayHTP = false;
        }else{
            this.closeHTP();
        }
        this.input.setTopOnly(true);

        //Add Scene event bindings
        this.events.on('resize',this.onSceneResize,this);
    }

    update(timestep,dt){
        if(this.timerActive){
            this.viewModel.update(timestep,dt);
        }
    }

    reorient(landscape:boolean){

        console.log("reorienting")

        if(this.preloaderUIScene){
            this.preloaderUIScene.reorient(landscape);
        }

        let position;
        let style;

        if(landscape){
            position = this.scaleManager.getRelativePosition(.5,.5);

            console.log("bg")

            if(this.bg){
                this.bg.setPosition(position.x,position.y);
                this.bg.setTexture('lan_gen_bg');
            }

            console.log("score container");
            
            if(this.scoreContainer)
            {
                position = this.scaleManager.getRelativePosition(0.1,0.05);
                this.scoreContainer!.setPosition(position.x,position.y);
                this.scoreLabel!.setPosition(position.x-55,position.y);
                this.score!.setPosition(position.x+20,position.y);
    
                this.scoreContainer!.setScale(1,1);
                this.scoreLabel!.setScale(1,1);
                this.score!.setScale(1,1);
            }
            
            console.log("round");

            if(this.round){
                position = this.scaleManager.getRelativePosition(0.3,0.05);
                this.roundContainer!.setPosition(position.x,position.y);
                this.roundLabel!.setPosition(position.x-55,position.y);
                this.round!.setPosition(position.x+20,position.y);

                this.roundContainer!.setScale(1,1);
                this.roundLabel!.setScale(1,1);
                this.round!.setScale(1,1);
            }

            console.log("life group");
            
            if(this.lifeGroup){
                position = this.scaleManager.getRelativePosition(0.5,0.05);
                this.lifeContainer!.setPosition(position.x,position.y);
                this.lifeLabel!.setPosition(position.x-55,position.y);

                this.lifeContainer!.setScale(1,1);
                this.lifeLabel!.setScale(1,1);

                for (let index = 0; index < this.lifeGroup!.length; index++) {
                    const element = this.lifeGroup![index];
                    element.setPosition(position.x + 4 + index * 35 ,position.y);
                    element.setScale(1,1);
                }
            }

            console.log("timercontainer");

            if(this.timerContainer)
            {
                position = this.scaleManager.getRelativePosition(0.7,0.05);
                this.timerContainer!.setPosition(position.x,position.y);
                this.timerLabel2!.setPosition(position.x-55,position.y);
                this.timerCounter!.setPosition(position.x + 10 ,position.y);

                this.timerContainer!.setScale(1,1);
                this.timerLabel2!.setScale(1,1);
                this.timerCounter!.setScale(1,1);
            }

            console.log("firstzone first image");

            if(this.firstZone && this.firstImageSprite){
                position = this.scaleManager.getRelativePosition(0.25,.5);
                this.firstImageContainerSprite!.setPosition(position.x,position.y);
                this.firstImageSprite!.setPosition(position.x,position.y);
                this.imageContainerTexture = 'lan_image_holder';
                this.firstImageContainerSprite!.setTexture(this.imageContainerTexture);

            
                this.firstZone.setPosition(position.x-(this.firstImageSprite.width/2),position.y-(this.firstImageSprite.height/2))
            }

            console.log("secondzone second image");
            
            if(this.secondZone && this.secondImageSprite){
                position = this.scaleManager.getRelativePosition(0.75,.5);
                this.secondImageContainerSprite!.setPosition(position.x,position.y);
                this.secondImageSprite!.setPosition(position.x,position.y);
                this.secondImageContainerSprite!.setTexture(this.imageContainerTexture);

            
                this.secondZone.setPosition(position.x-(this.secondImageSprite.width/2),position.y-(this.secondImageSprite.height/2))
            }

            console.log("timer progress bar bg");

            position = this.scaleManager.getRelativePosition(0.5,0.925);    
            if(this.timerProgressBarBg){
                this.timerProgressBarBg.setPosition(position.x,position.y);
                this.timerProgressBarBg.setTexture('lan_timer_ctn');
                this.progressBarWidth = 960;
                this.progressBarHeight = 20;
                this.progressBarPosition = new Phaser.Math.Vector2(position.x-(this.progressBarWidth/2), position.y);
                
                this.timerLabel!.setPosition(position.x,position.y);
                this.updateProgressBar(this.progressBarValue);
            }

            console.log("nextquestionbutton");

            if(this.nextQuestionButton)
            {
                position = this.scaleManager.getRelativePosition(0.5,0.5);
                position.y += 200;
                Phaser.Actions.SetXY(this.nextQuestionButton!.group.getChildren(),position.x,position.y);
                this.nextQuestionButtonPosition = position;

                position = this.scaleManager.getRelativePosition(1,0.05);
                Phaser.Actions.SetXY(this.pauseButton!.group.getChildren(),position.x-50,position.y);
            }

            
        }else{

            if(this.bg)
            {
                position = this.scaleManager.getRelativePosition(.5,.5);
                this.bg!.setPosition(position.x,position.y);
                this.bg!.setTexture('por_gen_bg');
            }
            
            if(this.scoreContainer){
                position = this.scaleManager.getRelativePosition(0.125,0.05);
                this.scoreContainer!.setPosition(position.x,position.y);
                this.scoreLabel!.setPosition(position.x-40,position.y);
                this.score!.setPosition(position.x+20,position.y);
          
                this.scoreContainer!.setScale(0.75,0.75);
                this.scoreLabel!.setScale(0.75,0.75);
                this.score!.setScale(0.75,0.75);
            }
            
    
            if(this.round){
                position = this.scaleManager.getRelativePosition(0.345,0.05);
                this.roundContainer!.setPosition(position.x,position.y);
                this.roundLabel!.setPosition(position.x-40,position.y);
                this.round!.setPosition(position.x+20,position.y);
    
                this.roundContainer!.setScale(0.75,0.75);
                this.roundLabel!.setScale(0.75,0.75);
                this.round!.setScale(0.75,0.75);
            }
            
            if(this.lifeGroup){
                position = this.scaleManager.getRelativePosition(0.56,0.05);
                this.lifeContainer!.setPosition(position.x,position.y);
                this.lifeLabel!.setPosition(position.x-40,position.y);
    
                this.lifeContainer!.setScale(0.75,0.75);
                this.lifeLabel!.setScale(0.75,0.75);
    
                for (let index = 0; index < this.lifeGroup.length; index++) {
                    const element = this.lifeGroup[index];
                    element.setPosition(position.x + 4 + index * 25 ,position.y);
                    element.setScale(0.75,0.75);
                }
            }

            if(this.timerContainer)
            {
                position = this.scaleManager.getRelativePosition(0.775,0.05);
                this.timerContainer!.setPosition(position.x,position.y);
                this.timerLabel2!.setPosition(position.x-40,position.y);
                this.timerCounter!.setPosition(position.x + 10 ,position.y);

                this.timerContainer!.setScale(0.75,0.75);
                this.timerLabel2!.setScale(0.75,0.75);
                this.timerCounter!.setScale(0.75,0.75);
            }

            if(this.firstZone && this.firstImageSprite){
                position = this.scaleManager.getRelativePosition(0.5,.3);
                this.firstImageContainerSprite!.setPosition(position.x,position.y);
                this.firstImageSprite!.setPosition(position.x,position.y);
                this.imageContainerTexture = 'por_image_holder';
                this.firstImageContainerSprite!.setTexture(this.imageContainerTexture);
            
                this.firstZone.setPosition(position.x-(this.firstImageSprite.width/2),position.y-(this.firstImageSprite.height/2))
            }
            
            if(this.secondZone && this.secondImageSprite){
                position = this.scaleManager.getRelativePosition(0.5,.725);
                this.secondImageContainerSprite!.setPosition(position.x,position.y);
                this.secondImageSprite!.setPosition(position.x,position.y);
                this.secondImageContainerSprite!.setTexture(this.imageContainerTexture);

            
                this.secondZone.setPosition(position.x-(this.secondImageSprite.width/2),position.y-(this.secondImageSprite.height/2))
            }

            position = this.scaleManager.getRelativePosition(0.5,0.975);    
            if(this.timerProgressBarBg){
                this.timerProgressBarBg.setPosition(position.x,position.y);
                this.timerProgressBarBg.setTexture('por_timer_ctn');
                this.progressBarWidth = 600;
                this.progressBarHeight = 20;
                this.progressBarPosition = new Phaser.Math.Vector2(position.x-(this.progressBarWidth/2), position.y);
                this.timerLabel!.setPosition(position.x,position.y);
                this.updateProgressBar(this.progressBarValue);
            }

            if(this.nextQuestionButton)
            {
                position = this.scaleManager.getRelativePosition(0.5,0.5);
                Phaser.Actions.SetXY(this.nextQuestionButton!.group.getChildren(),position.x,position.y);
                this.nextQuestionButtonPosition = position;
    
                position = this.scaleManager.getRelativePosition(1,0.05);
                Phaser.Actions.SetXY(this.pauseButton!.group.getChildren(),position.x-50,position.y);
            }
            
        }

        //if timer is not active, htp is closed, and pauseScene is closed, relocate boxes
        if(this.timerActive == false )
        {
            if(this.htpScene.open == false && ( this.pauseScene.open == false || this.viewModel.isCurrentChoiceCorrect() == false))
            {

                var color
                if(this.viewModel.isCurrentChoiceCorrect())
                {
                    color = 0x39ff14;
                }
                else if(!this.viewModel.isCurrentChoiceCorrect()) color = 0xea3142;
                if(this.graphics && this.firstZone && this.secondZone){
                    
                    this.graphics.clear();
                    this.graphics.lineStyle(5,color,1);
                    let p1 = this.viewModel.getAnswerZoneRectangleUpperLeft();
                    let p2 = this.viewModel.getAnswerZoneRectangleLowerRight();
                    let rectX = this.firstZone.x + p1.x;
                    let rectY = this.firstZone.y + p1.y;
                    let width = p2.x - p1.x;
                    let height = p2.y - p1.y;
                    let rect = new Phaser.Geom.Rectangle(rectX,rectY,width,height);
                    this.graphics.strokeRectShape(rect);
                    rectX = this.secondZone.x + p1.x;
                    rectY = this.secondZone.y + p1.y;
                    rect = new Phaser.Geom.Rectangle(rectX,rectY,width,height);
                    this.graphics.strokeRectShape(rect);
                }
                
            }

           
            
        }

        // if(this.viewModel.isCurrentChoiceCorrect() == false && (this.htpScene.open == true || this.pauseScene.open == true))
        // {
        //     this.graphics!.visible = false;
        // }
        // else{
        //     this.graphics!.visible = true;
        // }

        this.rescaleBackground();
        console.log("completed reorient")
    }

    rescaleBackground():void {
        //rescale background
        let ratio = this.scaleManager.getRatio();

        if(this.bg!.width * this.bg!.scaleX != window.innerWidth || this.bg!.height * this.bg!.scaleY != window.innerHeight)
        {
            this.bg!.setScale(this.sys.canvas.width/this.bg!.width / ratio! , this.sys.canvas.height/this.bg!.height / ratio!);
        }
    }

    onSceneResize()
    {
        this.rescaleBackground();
    }

    onTimerEnd(){
        if(this.nextQuestionButtonActive != true)
            this.sound.play('ding');
        if(this.timerProgressBar){
            if(Math.round(this.viewModel.getTimerProgress()* 100)/100 < 0.01){
                this.timerProgressBar.setVisible(false);
            }
        }
        this.showQuestionResults();
    }

    closeHTP(){
        this.gameManager.cbnGameConfig!.willDisplayHTP = false;
        this.timerActive = true;
        this.scene.resume(undefined!);
    }

    onZoneDown(pointer,localX,localY){
        let answer = new Phaser.Math.Vector2(localX,localY);
        console.log(answer);
        this.viewModel.giveAnswer(answer);
    }

    showAttemptResults(){
        let result:boolean = this.viewModel.isCurrentChoiceCorrect();
        if(result){
        }else{
            if(this.nextQuestionButtonActive != true)
                this.sound.play('wrong');
            this.progressBarColor = 0xea3142;
            this.tweens.add({
                targets: this,
                progressBarHeight: '+= 20',
                progressBarWidth: '+= 20',
                duration: 100,
                yoyo: true,
                onComplete: function (tween,target:EagleEyeExamGameScene) { 
                    console.log('onComplete'); 
                    target[0].progressBarColor = 0x1999f1;
                    target[0].progressBarHeight = 20;
                    console.log(target.progressBarColor);
                    console.log(arguments);
                },
            });
            if(this.timerLabel){
                this.tweens.add({
                    targets: this.timerLabel,
                    scaleX:1.5,
                    scaleY:1.5,
                    duration: 100,
                    yoyo: true,
                });
            }

            if(this.firstImageContainerSprite){
                this.imageContainerTexture = this.scaleManager.isOrientationLandscape() ? 'lan_image_holder_wrong' : 'por_image_holder_wrong';
                this.firstImageContainerSprite.setTexture(this.imageContainerTexture);
                this.tweens.addCounter({
                    duration: 1000,
                    ease: 'Power2',
                    onComplete: function(tween:Phaser.Tweens.Tween,targets:Phaser.GameObjects.Sprite[],params){
                        params.scene.imageContainerTexture = params.scene.scaleManager.isOrientationLandscape() ? 'lan_image_holder' : 'por_image_holder';
                        params.setTexture(params.scene.imageContainerTexture);
                    },
                    onCompleteParams: this.firstImageContainerSprite
                });
            }

            if(this.secondImageContainerSprite){
                this.imageContainerTexture = this.scaleManager.isOrientationLandscape() ? 'lan_image_holder_wrong' : 'por_image_holder_wrong';
                this.secondImageContainerSprite.setTexture(this.imageContainerTexture);
                this.tweens.addCounter({
                    duration: 1000,
                    ease: 'Power2',
                    onComplete: function(tween:Phaser.Tweens.Tween,targets:Phaser.GameObjects.Sprite[],params){
                        params.scene.imageContainerTexture = params.scene.scaleManager.isOrientationLandscape() ? 'lan_image_holder' : 'por_image_holder';
                        params.setTexture(params.scene.imageContainerTexture);
                    },
                    onCompleteParams: this.secondImageContainerSprite
                });
            }
        }
    }

    showQuestionResults(){
        if(this.score){
            this.score.setText(this.viewModel.getCurrentScore().toString());
        }
        this.updateLives();
        this.timerActive = false;
        let result:boolean = this.viewModel.isCurrentChoiceCorrect();
        let color;
        if(result){
            this.sound.play('correct');
            //Play Score Animation FX
            if(this.scoreContainer){
                if(this.scoreFxBar && this.scoreFxStar && this.containerWhiteFx){
                    this.scoreFxBar.setPosition(this.scoreContainer.x,this.scoreContainer.y);
                    this.containerWhiteFx.setPosition(this.scoreContainer.x,this.scoreContainer.y);
                    this.scoreFxStar.setPosition(this.scoreContainer.x - (this.scoreContainer.width/2),this.scoreContainer.y);
                    this.scoreFxBar.setAlpha(0);
                    this.tweens.add({
                        targets: [this.scoreFxBar,this.scoreFxStar,this.containerWhiteFx],
                        alpha: 1,
                        duration: 500,
                        ease: 'Power3'
                    });
                    let timeline = this.tweens.createTimeline({});
                    timeline.add({
                        targets: this.scoreFxStar,
                        x: {value:"+="+this.scoreContainer.width, duration:500, ease: "Power3"}
                    });
                    timeline.add({
                        targets: [this.scoreFxBar,this.scoreFxStar,this.containerWhiteFx],
                        alpha: 0,
                        duration: 250,
                        ease: 'Expo.easeOut'
                    });
                    timeline.play();
                }
            }
            color = 0x39ff14;
            
        }else{
            if(this.nextQuestionButtonActive != true)
                this.sound.play('wrong');
            color = 0xea3142;
        }

        if(this.graphics && this.firstZone && this.secondZone){
                
            this.graphics.clear();
            this.graphics.lineStyle(5,color,1);
            let p1 = this.viewModel.getAnswerZoneRectangleUpperLeft();
            let p2 = this.viewModel.getAnswerZoneRectangleLowerRight();
            let rectX = this.firstZone.x + p1.x;
            let rectY = this.firstZone.y + p1.y;
            let width = p2.x - p1.x;
            let height = p2.y - p1.y;
            let rect = new Phaser.Geom.Rectangle(rectX,rectY,width,height);
            this.graphics.strokeRectShape(rect);
            rectX = this.secondZone.x + p1.x;
            rectY = this.secondZone.y + p1.y;
            rect = new Phaser.Geom.Rectangle(rectX,rectY,width,height);
            this.graphics.strokeRectShape(rect);
        }

        if(this.firstZone){
            this.firstZone.input.enabled = false;
        }
        
        if(this.secondZone){
            this.secondZone.input.enabled = false;
        }

        //Animate Next Question Button
        if(this.nextQuestionButtonPosition){
            Phaser.Actions.SetXY(this.nextQuestionButton!.group.getChildren(),this.nextQuestionButtonPosition.x,this.nextQuestionButtonPosition.y);
        }else{
            console.error('nextButtonPosition is null');
        }
        Phaser.Actions.SetVisible(this.nextQuestionButton!.group.getChildren(),true);
        this.nextQuestionButton!.sprite.setInteractive();
        this.nextQuestionButtonActive = true;
    }

    showNextQuestion(){
        this.viewModel.clearAnswer();
        this.viewModel.nextQuestion();
        if(this.viewModel.isQuizDone())
            return;
      
        if(this.gameManager.cbnGameConfig!.gameType != GameType.daily)
        {
            if(this.timerProgressBar){
                this.timerProgressBar.setVisible(true);
              }
            //Enable Choice Buttons
            if(this.firstZone){
                this.firstZone.setInteractive();
            }
            if(this.secondZone){
                this.secondZone.setInteractive();
            }
            if(this.graphics){
                this.graphics.clear();
            }
            //Update Quiz View
            this.updateQuizView();
            //Resume Time if quiz is not done
            if(this.viewModel.isQuizDone()==false){
                this.timerActive = true;
                this.scene.resume(undefined!);
            }
            //Disable nextQuestionButton
            Phaser.Actions.SetVisible(this.nextQuestionButton!.group.getChildren(),false);
            this.nextQuestionButtonActive = false;
            this.nextQuestionButton!.sprite.setTexture('next_question_button');
        }
        
        
        
        this.input.disable(this.nextQuestionButton!.sprite);
        
    }

    updateQuizView(){
        if(this.viewModel.isQuizDone()==false){
            this.updateImages();
            this.updateScore();
            this.updateRound();
            this.updateLives();
            this.updateQuizTimer();
        }
    }

    updateImages(){

        if(this.firstImageSprite){
            if(this.viewModel.getFirstImageKey() == "")
            {
                this.viewModel.setFirstImageKey('firstImage'+(this.viewModel.getCurrentQuestion()));
            }
            this.firstImageSprite.setTexture(this.viewModel.getFirstImageKey());
        }
        if(this.secondImageSprite){
            if(this.viewModel.getSecondImageKey() == "")
            {
                this.viewModel.setSecondImageKey('secondImage'+(this.viewModel.getCurrentQuestion()));
            }
            this.secondImageSprite.setTexture(this.viewModel.getSecondImageKey());
        }
    }

    updateScore(){
        if(this.score){
            this.score.setText(this.viewModel.getCurrentScore().toString());
        }
    }

    updateRound(){
        if(this.round){
            this.round.setText(this.viewModel.getCurrentRoundNumber().toString());
        }
    }

    updateLives(){

        if(this.lifeGroup == null) return;
        
        let array = this.lifeGroup;
        for (let index = 0; index < array!.length; index++) {
            let texture = this.viewModel.getCurrentLife() > index ? 'gfx_life_on' : 'gfx_life_off';
            array![index].setTexture(texture);
        }
    }

    updateQuizTimer(){
        if(this.timerProgressBar){
            this.updateProgressBar(this.viewModel.getTimerProgress());
        }
    }

    updateProgressBar(value){
        if(this.progressBarWidth! > 960) this.progressBarWidth = 960;
        this.timerProgressBar!.clear();
        this.timerProgressBar!.fillStyle(this.progressBarColor, 1);
        this.timerProgressBar!.fillRect(this.progressBarPosition!.x, this.progressBarPosition!.y - ((this.progressBarHeight!)/2), this.progressBarWidth! * value, this.progressBarHeight!);
        this.progressBarValue = value;

        if(this.timerCounter)
        {
            var minutes = Math.floor(Math.round(this.viewModel!.getGameTimeRemaining()) / 60);
            var seconds = Math.round(this.viewModel!.getGameTimeRemaining()) - minutes * 60;

            var timeLeft;
            if(seconds.toString().length == 1)
            {
                timeLeft = minutes + ":0" + seconds;
            }
            else timeLeft = minutes + ":" + seconds;
        
        
            this.timerCounter!.setText(timeLeft);
        }
        
    }

    onPauseScene(){
        if(this.pauseScene.open==false && this.htpScene.open==false){
            this.timerActive = false;
            this.scene.pause(undefined!);
            this.pauseScene.startOpen();
        }
    }

    onUnpauseScene(){
        if(this.nextQuestionButtonActive==false){
            this.timerActive = true;
        }
        this.scene.resume(undefined!);
    }

    onEndQuiz(){
        console.log(`Ending Quiz!`);
        if(this.preloaderUIScene){
            this.scene.remove(this.preloaderUIScene.gizmoScene);
        }

        this.viewModel.resetImageKeys();
        
        this.scene.remove(this.pauseScene.scene.settings.key);
        if(this.htpScene.scene) this.scene.remove(this.htpScene.scene.settings.key);
        let nextScene = new TitleScene({key:'TitleScene'+Math.random()});
        if( this.gameManager.cbnGameConfig!.gameType != GameType.daily) {
            SceneManager.changeScene(this,nextScene);
        }

        var textures = this.textures.getTextureKeys();
        for( let i = 0 ; i < textures.length; i++)
        {
        if(textures[i].indexOf('answer') == 0 || textures[i].indexOf('question') == 0)
        {
            this.textures.get(textures[i]).destroy();
        }
        }
    }

    checkIfInterrupt(){
        if ((<any>window.document).webkitHidden || window.document.hidden) {
            this.onPauseScene();
        }
    }
}